module.exports = __webpack_public_path__ + "static/media/unikpeople-logo.088f3de2.png";